// src/pages/Workforce/AttendanceCalendarView.jsx
import React from "react";
import { Legend, STATUS_CFG } from "./AttendenceShared";

export default function AttendanceCalendarView({
  isAdmin, gridData, year, month, daysInMonth,
  calendarEmpId, setCalendarEmpId, myWorkforceId,
  setModalCell, setModalEmpName
}) {
  const now = new Date();
  const targetEmpId = isAdmin ? calendarEmpId : myWorkforceId;
  const calendarEmpData = gridData.find(e => String(e.id) === String(targetEmpId));
  const calendarDays = calendarEmpData?.days || [];
  
  const firstDayOfMonth = new Date(year, month - 1, 1).getDay(); // 0 = Sun, 6 = Sat
  const blanks = Array.from({ length: firstDayOfMonth }, (_, i) => i);
  const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  return (
    <div className="animate-in fade-in duration-200 flex-1 flex flex-col">
      {isAdmin && (
        <div className="mb-4 flex items-center gap-3 bg-white dark:bg-[#161b22] p-3 rounded-xl border border-gray-200 dark:border-[#30363d] shadow-xs w-fit shrink-0">
          <span className="text-sm font-bold text-gray-700 dark:text-slate-200">Select Employee:</span>
          <select
            value={calendarEmpId}
            onChange={(e) => setCalendarEmpId(e.target.value)}
            className="p-2 bg-gray-50 dark:bg-[#0d1117] border border-gray-300 dark:border-[#30363d] dark:text-white rounded-md text-sm outline-none focus:ring-2 focus:ring-blue-500 font-medium"
          >
            {gridData.map(emp => (
              <option key={emp.id} value={emp.id}>{emp.name} ({emp.employee_id || emp.role})</option>
            ))}
          </select>
        </div>
      )}

      <Legend />

      <div className="bg-white dark:bg-[#161b22] rounded-xl shadow-xs border border-gray-200 dark:border-[#30363d] overflow-hidden mb-8">
        <div className="grid grid-cols-7 border-b border-gray-200 dark:border-[#30363d] bg-gray-50 dark:bg-[#21262d]">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
            <div key={d} className="py-3 text-center text-xs font-bold text-gray-500 dark:text-slate-400 uppercase tracking-wider border-r border-gray-200 dark:border-[#30363d] last:border-r-0">
              {d}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-7 bg-gray-200 dark:bg-[#30363d] gap-[1px]">
          {blanks.map(b => <div key={`blank-${b}`} className="bg-gray-50 dark:bg-[#161b22] min-h-[100px] md:min-h-[120px]"></div>)}
          
          {daysArray.map(d => {
            const dayData = calendarDays.find(cd => cd.day === d);
            const isToday = year === now.getFullYear() && month === now.getMonth() + 1 && d === now.getDate();
            const cfg = STATUS_CFG[dayData?.status] || STATUS_CFG.future;
            const isWeekend = new Date(year, month - 1, d).getDay() === 0 || new Date(year, month - 1, d).getDay() === 6;

            return (
              <div key={d}
                className={`bg-white dark:bg-[#161b22] min-h-[100px] md:min-h-[120px] p-2 flex flex-col transition hover:bg-blue-50/30 dark:hover:bg-slate-800/40 ${isToday ? 'ring-2 ring-inset ring-blue-500' : ''}`}
                onClick={() => {
                  if (dayData && dayData.status !== 'future' && dayData.status !== 'weekend') {
                    setModalCell(dayData);
                    setModalEmpName(calendarEmpData?.name);
                  }
                }}
                style={{ cursor: (dayData && dayData.status !== 'future' && dayData.status !== 'weekend') ? 'pointer' : 'default' }}
              >
                <div className="flex justify-between items-start mb-2">
                  <span className={`text-xs font-bold w-6 h-6 flex items-center justify-center rounded-full ${isToday ? 'bg-blue-600 text-white' : isWeekend ? 'text-red-500' : 'text-gray-700'}`}>
                    {d}
                  </span>
                  {dayData && dayData.status !== 'future' && dayData.status !== 'weekend' && (
                    <div title={cfg.label}>{cfg.icon}</div>
                  )}
                </div>

                {dayData && dayData.status !== 'future' && dayData.status !== 'weekend' && (
                  <div className="mt-auto space-y-1">
                    <div className="text-[10px] font-bold text-gray-500 flex justify-between">
                      <span>In:</span>
                      <span className="text-gray-800">{dayData.check_in || '--'}</span>
                    </div>
                    <div className="text-[10px] font-bold text-gray-500 flex justify-between">
                      <span>Out:</span>
                      <span className="text-gray-800">{dayData.check_out || '--'}</span>
                    </div>
                    {dayData.working_hours && (
                      <div className="text-[10px] font-bold text-blue-600 bg-blue-50 rounded px-1 text-center mt-1">
                        {dayData.working_hours} hrs
                      </div>
                    )}
                  </div>
                )}
                {dayData?.status === 'holiday' && <div className="mt-auto text-[10px] font-bold text-amber-600 bg-amber-50 rounded px-1 text-center py-1">Holiday</div>}
                {dayData?.status === 'on_leave' && <div className="mt-auto text-[10px] font-bold text-red-600 bg-red-50 rounded px-1 text-center py-1">On Leave</div>}
              </div>
            );
          })}
          {/* Fill remaining slots */}
          {Array.from({ length: (7 - ((blanks.length + daysArray.length) % 7)) % 7 }).map((_, i) => (
            <div key={`end-blank-${i}`} className="bg-gray-50 min-h-[100px] md:min-h-[120px]"></div>
          ))}
        </div>
      </div>
    </div>
  );
}